// BarthelIndexのReducer
import * as BarthelIndex from '../../constants/BarthelIndexAPI';

const initialState = {
  Loading: false,
  Loaded: false,
};

export function barthelIndex(state: any = initialState, action: any) {
  switch (action.type) {
    case BarthelIndex.SUCCESS:
      return Object.assign({}, state, {
        Loading: false,
        Loaded: true,
        result: action.result,
      });
    case BarthelIndex.ERROR:
      return Object.assign({}, state, {
        Loading: false,
        Loaded: true,
        result: action.result,
      });
    case BarthelIndex.LOADING:
      return Object.assign({}, state, {
        Loading: true,
        Loaded: false,
      });
    case BarthelIndex.INITIALIZE:
      return Object.assign({}, state, {
        Loading: false,
        Loaded: false,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/BarthelIndex.tsx